import axios from 'axios';

export const workflowContainerCheckPointApi = axios.create({
    baseURL: `${process.env.REACT_APP_BACKEND!}api/workflow-container-checkpoint`,
    headers: {
        'Content-Type': 'application/json'
    }
})